import {Box, Divider, IconButton, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import React from 'react';

import {Close} from '@icons/index';
import {Colors} from '@constants/colors.constants';

import {IssueStatus, ManageIssue} from '@store/operations/issues';

interface ManageIssueHeaderProps {
  isCreation?: boolean;
  issue: ManageIssue;
  handleClose: () => void;
  status?: IssueStatus;
}

const ManageIssueHeader = (props: ManageIssueHeaderProps) => {
  const {isCreation, handleClose, status, issue} = props;

  const {t} = useTranslation();

  return (
    <>
      <Stack direction="row" justifyContent="flex-end">
        <IconButton onClick={handleClose}>
          <Close/>
        </IconButton>
      </Stack>
      {/*{!isCreation && (*/}
      {/*  <Typography fontSize={12} fontWeight="400" mb="3px" color={Colors.textWithOpacity}>*/}
      {/*    {t('global.createdBy', {by: {firstName: issue.author?.firstName, lastName: issue.author?.lastName[0]}})}*/}
      {/*  </Typography>*/}
      {/*)}*/}
      <Stack pr="10px">
        <Stack direction="row" alignItems="center" mb="15px" spacing={1.5}>
          <Typography fontSize={24} fontWeight="700">
            {t(`operations.nonCompliance.manage.title.${isCreation ? 'add' : 'edit'}`, {issue: issue.issueSignature})}
          </Typography>
          {!isCreation && !!status && (
            <Box bgcolor={Colors.background} p="8px">
              <Typography textAlign="center" textTransform="uppercase">
                {IssueStatus.selectItems().find((s) => s.value === status)?.label || ''}
              </Typography>
            </Box>
          )}
        </Stack>
        <Divider variant="fullWidth" orientation="horizontal"/>
      </Stack>
    </>
  );
};

export default ManageIssueHeader;
